import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './rotations-list.module.scss';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useDateFormatter } from 'shared/hooks/dates.hooks';
import { toInclusiveEndDate } from 'shared/utils/date.utils';
import analyticsService from 'src/helpers/analytics.service';
import { EVENTS, INTERNAL_ROUTING } from 'shared/constants';
import { AcgmeBadge } from '../components/acgme-badge.component';

const RotationItem = ({ item, ...props }) => {
  const { name, id, start, end, isAcgmeRequired } = item;
  const { formatRangeDate } = useDateFormatter();
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const selected = searchParams.get(INTERNAL_ROUTING.QUERY_PARAMS.ROTATIONS) === id;

  const handleClick = () => {
    searchParams.set(INTERNAL_ROUTING.QUERY_PARAMS.ROTATIONS, id);
    navigate({ search: searchParams.toString() });

    analyticsService.track(EVENTS.ROTATIONS.OPEN, { rotationId: id, name });
  };

  return (
    <button
      className={classNames(styles.item, selected ? styles.itemSelected : '')}
      onClick={handleClick}
      {...props}>
      {start && end && (
        <p className={styles.dates}>{formatRangeDate(start, toInclusiveEndDate(end))}</p>
      )}
      <div className={styles.titleRow}>
        <p className={classNames(styles.itemTitle, selected ? styles.itemSelectedText : '')}>
          {name}
        </p>
        {isAcgmeRequired && <AcgmeBadge size="small" />}
      </div>
    </button>
  );
};

export { RotationItem };
